import './style.less'

export function ButtonLightBlue(){
    return(
        <button className='ButtonLightBlue'>
            Mensagens
        </button>
    )
}
